module.exports = __webpack_public_path__ + "img/iconCheckMark.c7fc215d.png";